import { IFilter } from '../../types/advancedFilters';
import { SuburbanAreaContainer } from '../../containers/advancedFilters/SuburbanAreaContainer';

export const suburbanArea: IFilter = {
  component: SuburbanAreaContainer,
};
